import { ISetFxRates } from 'constants/actionTypes';
import { FX_RATES_ACTIONS } from 'constants/enums';
import { IFxRate } from 'constants/storeTypes';

export const setFxRates = (fxRates: { [id: string]: IFxRate[] }): ISetFxRates => ({
  type: FX_RATES_ACTIONS.SET_FX_RATES,
  fxRates,
});
